import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";

export function ImportAssistButton(props: ButtonProps) {
  return (
    <Button
      id="importAssistTrigger"
      variant="solid"
      colorScheme="primary"
      onClick={() => {
        /* !!important - clear the focused element so as not to interfere with typing in Intercom */
        (document.activeElement as HTMLElement | null)?.blur();
      }}
      {...props}
    >
      Request assisted import
    </Button>
  );
}
